export const sdkUrl = 'https://connect.facebook.net/en_US/sdk.js'
